import React from "react";
interface ProductImageDisclaimerProps {
  isImageSelected: boolean;
  productImageDisclaimer?: string;
}
const ProductImageDisclaimer = ({
  isImageSelected,
  productImageDisclaimer
}: ProductImageDisclaimerProps) => {
  return isImageSelected && productImageDisclaimer ? <div className="bg-white text-sm leading-3 my-3 text-center" data-testid="productImageDisclaimer"
  // TODO: remove dangerouslySetInnerHTML
  // eslint-disable-next-line react/no-danger
  dangerouslySetInnerHTML={{
    __html: `Note: ${productImageDisclaimer}`
  }} data-sentry-component="ProductImageDisclaimer" data-sentry-source-file="ProductImageDisclaimer.tsx" /> : <></>;
};
export default ProductImageDisclaimer;